<template>
  <v-layout class="pt-4">
    <v-flex xs12 sm10 offset-sm1>
      <v-card class="tabs_style">
        <v-tabs centered color="primary" dark text grow v-model="active">
          <v-tabs-slider color="secondary"></v-tabs-slider>

          <v-tab href="#tab-1" class="text-capitalize">{{$translate('EVENT_DETAILS')}}</v-tab>
          <v-tab
            href="#tab-2"
            class="text-capitalize"
            v-if="$store.getters.getChosenEvent.Type !== 'Standard' &&
            $store.getters.getChosenEvent.Type !== 'Webshop'"
          >{{$translate('BATCHGROUPS')}}</v-tab>
          <v-tab
            href="#tab-3"
            v-if="$store.getters.getChosenEvent.Type === 'Rental' ||
                  $store.getters.getChosenEvent.Type === 'Webshop'"
            class="text-capitalize"
          >{{$translate('PRODUCTS')}}</v-tab>
          <v-tab href="#tab-4" class="text-capitalize">{{$translate('COMMUNICATION')}}</v-tab>

          <v-tab-item v-for="i in tabsNumber" :key="i" :value="'tab-' + i" justify-center>
            <v-container grid-list-xl text-xs-center>
              <Events-Editing v-if="i===1" class="tab_container"/>
              <Events-Batchgroups v-if="i===2" class="tab_container"/>
              <Events-Products v-if="i===3" class="tab_container"/>
              <Events-Messages v-if="i===4" class="tab_container"/>
            </v-container>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>

import Events_Editing from "@/components/Events/Events_Editing";
import Events_Messages from "@/components/Events/Events_Messages";
import Events_Batchgroups from "./Events_Batchgroups";
import Events_Products from "./Events_Products";
import { ui_helpers } from "../../shared/ui_helpers";
import { mapGetters } from "vuex";

export default {
  name: "Events_main_old",
  components: {
    "Events-Batchgroups": Events_Batchgroups,
    "Events-Editing": Events_Editing,
    "Events-Messages": Events_Messages,
    "Events-Products": Events_Products
  },
  computed: {
    ...mapGetters({
      tabIdAccountManagement: "getTabIdAccountManagement",
    })
  },

 watch: {
    tabIdAccountManagement: function(n, o) {
      this.active = "tab-" + n;
    }
 },
  data() {
    return {
        tabsNumber: 4,
        active: null,

    }
  },
  mounted() {
    }


}
</script>

<style lang="scss" scoped>

.tab_container {
  height: 70vh;
  overflow-x: hidden;
  overflow-y: auto;
}
.tabs_style {
  border-radius: 2em;
}

</style>
